export default __webpack_public_path__ + "static/Metal_Wall_Sign-fc7f07efef7eaa22c5c66f82de6f3b65.png";